import React, { useState } from "react";
import "./Navbar.css";
import Toggle from "../Toggle/Toggle";
import { themeContext } from "../../Context";
import { useContext } from "react";
import Cv from "../../img/fw20_0863_Vipul_Vatsa_Resume.pdf";
import { Button, Link } from "@chakra-ui/react";

function Navbar() {
  const [menu, setMenu] = useState(false);
  const navbar = () => {
    if (menu === true) {
      setMenu(false);
    } else {
      setMenu(true);
    }
  };
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;
  // const resume=()=>{
  //       href={Cv}
  // }
  return (
    <div className="n-wrapper" id="Navbar">
      {/* left */}
      <div className="n-left ml-2">
        <a
          style={{
            textDecoration: "none",
            color: darkMode ? "white" : "black",
          }}
          href="#home"
        >
          <div className="n-name">Vipul</div>
        </a>
        {/* <Toggle /> */}
        {/* <p className="mt-3">
          <Toggle />
        </p> */}
      </div>
      {/* right */}
      <div className="n-right">
        <div className="n-list">
          <ul style={{ listStyleType: "none" }}>
            <a href="#home" style={{ color: darkMode ? "white" : "black" }}>
              <li className="mt-3">Home</li>
            </a>
            <a href="#services" style={{ color: darkMode ? "white" : "black" }}>
              <li className="mt-3">About</li>
            </a>
            <a href="#skills" style={{ color: darkMode ? "white" : "black" }}>
              <li className="mt-3">Skills</li>
            </a>
            <a href="#projects" style={{ color: darkMode ? "white" : "black" }}>
              <li className="mt-3">Projects</li>
            </a>
            <a href="#contact" style={{ color: darkMode ? "white" : "black" }}>
              <li className="mt-3">Contact</li>
            </a>
            
            <Button
              
              color="white"
              _hover={{ color: "#09a672" }}
              fontWeight=""
            
              mt="20px"
              as={Link}
              href={Cv}
              download
              onClick={() =>
                window.open(
                  "https://drive.google.com/file/d/1MAi7Ex8gl8qWaPlVr8CVx2VeoBYdwGvw/view?usp=share_link",
                  "_blank"
                )
              }
            >
              Resume
            </Button>
          </ul>
        </div>
        
        {menu ? (
          <i onClick={navbar} class="menu fa-solid fa-xmark"></i>
        ) : (
          <i onClick={navbar} class="menu fa-solid fa-bars"></i>
        )}
      </div>
      {menu && (
        <div style={{ background: darkMode ? "black" : "" }} className="show">
          <ul>
          <a href="#home">
              <li>Home</li>
            </a>
            <a href="#services">
              <li>About</li>
            </a>
            <a href="#skills">
              <li>Skills</li>
            </a>
            <a href="#projects">
              <li>Projects</li>
            </a>
            <a href="#contact">
              <li>Contact</li>
            </a>
            <a
              activeClass="active"
              target="_blank"
              rel="noopener noreferrer"
              href={Cv}
              download
              onClick={() =>
                window.open(
                  "https://drive.google.com/file/d/1MAi7Ex8gl8qWaPlVr8CVx2VeoBYdwGvw/view?usp=share_link",
                  "_blank"
                )
              }
              style={{ color: darkMode ? "white" : "black" }}
            >
              <li>Resume</li>
            </a>
          </ul>
        </div>
      )}
    </div>
  );
}

export default Navbar;
